import { Wallet } from "ethers";
import { decodeSuiPrivateKey } from '@mysten/sui/cryptography';

export function isValidPrivateKey(privateKey: string = '') {
  try {
    const { scheme, secretKey } = decodeSuiPrivateKey(privateKey);
    // scheme: 'ED25519' | 'Secp256k1' | 'Secp256r1'
    // secretKey: Uint8Array(32)
    return !!scheme && secretKey.length === 32;
  } catch {
    return false;
  }
}

export function isValidSuiPrivateKey(value?: string): boolean {
  if (!value) return false;
  const v = value.trim();
  try {
    const parsed = decodeSuiPrivateKey(v);
    // decodeSuiPrivateKey 会验证 suiprivkey + 33-byte(flag||key) 结构
    // 解析成功即可认为合法
    return !!parsed;
  } catch {
    return false;
  }
}